module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAATNJREFUSEtjZKAxYKSx+QyjFhAMYfoG0bxYGXNmRoYn8YuePCXoNDQFDQ4MLDLS0vY/f/06mb369ReYNNwH82Nkyv8zMHYwMDB8YPr/1ydh6bOjxFoyNVSUh5OdYzsDA4PNfwaGM8lLHptiWDA3RmY7IwOjB0ji////X5gZ/nkQYwmy4VC9f/78+yeZvvzZGxAf7oOZkVIarMzM+xkYGCSItQTdcIg+hpzkpY+nYvgAJECKJdgMZ2T4X5C45MlE5KDFSEXEWEKs4ShBhGwrPktIMRynBbiCi/H/3xAGJpYaUGpBhDFmsOANInw+QU+22MIcUw2BxI4eXMS6HGsqwmUXuiXEuJwkC5DjhJHhfwd6UsQXCCQVdvMDBAQSN3z4QGwRgjcVkWII1XxAjqUkBdHItAAAOf6cGd4JIjsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookIcons/downarrow.png
// module id = /Tw3
// module chunks = 1